import { useEffect, useRef } from "react";
import { Connector } from "@web3-react/types";

export const useConnectEagerly = (connector: Connector, name: string) => {
  const connectorRef = useRef<Connector | undefined>(undefined);
  useEffect(() => {
    if (connector === connectorRef.current) {
      return;
    }
    connectorRef.current = connector;
    void connector.connectEagerly?.()?.catch((e) => {
      console.debug(name + ": failed to load eagerly", e);
    });
  }, [connector]);
};
